export default __webpack_public_path__ + "static/autism-connect-sm-7152e4d7ee2b38d5d6ea8be8ae5dc1ed.svg";